<template>
  <top-nav />
  <main class="main">
    <spp-banner />
    <div v-show="currentTab === 'overview'" v-if="toShowOverviewTab">
      <overview-tab />
    </div>
    <div class="abStatus" v-show="currentTab === 'alberta'">
      <ab-status-tab />
    </div>
    <div class="osr abStatus " v-show="currentTab === 'osr'" v-if="toShowOSRTab">
      <osr-tab />
    </div>
  <div class="osr abStatus " v-show="currentTab === 'mammalOsr'" v-if="true">
    <osr-mammal-tab />
  </div>
    <reference-section />
  </main>
</template>

<script>
/**
Tabs:
  Overview:
    About Species (images + writeup content about the spp habitat and charictersic )
    Occurrence map
    Naturelynx Images
    Reference (same on all tabs)
  AB Status:
    Species Info: show links to all subsections
    Maps: difference slider map and reference diff maps.
    Habitat association: charts (full, few detctions, Tree + Nontree, HF linear)
    HF section: sector effect charts

  OSR Status:
  OSR Mammal Status:
Special cases:
  1. When no species information write ups, only show the AB Status Tab
    but place the occurrence map in the AB Status Tab.
  2. When no information on the maps, and charts, don't display AB status tab.
    display no-spp text message on the overview tab, and show the overview tab as AB Status tab.

 */
import { defineComponent, onMounted } from 'vue';
import { useApp } from '@/composables/state/profileState';
import { useI18n } from 'vue-i18n';
import Banner from '@/modules/speciesProfile/Banner.vue';
import OverviewTab from '@/modules/speciesProfile/overview/OverviewTab.vue';
import ABStatusTab from '@/modules/speciesProfile/ABStatus/ABStatusTab.vue';
import TopNav from '@/modules/speciesProfile/TopNav.vue';
import ReferenceSection from '@/modules/speciesProfile/ReferenceSection.vue';
import OSRTab from '../modules/speciesProfile/osrTab/OSRTab.vue';
import OSRMammalTab from '../modules/speciesProfile/osrMammalTab/OSRMammalTab.vue';

export default defineComponent({
  name: 'SpeciesProfile-MainPage',
  components: {
    'spp-banner': Banner,
    'overview-tab': OverviewTab,
    'ab-status-tab': ABStatusTab,
    'top-nav': TopNav,
    'reference-section': ReferenceSection,
    'osr-mammal-tab': OSRMammalTab,
    'osr-tab': OSRTab,
  },
  props: ['year'],
  setup (props) {
    const { state, currentTab, toShowOverviewTab, toShowOSRTab } = (useApp());
    const { tm, te } = useI18n();
    onMounted(async () => {
      const { init } = useApp();
      await init(false, tm, te);
      // toShowOverviewTab } = (useApp());
    });

    return {
      state,
      currentTab,
      toShowOverviewTab,
      toShowOSRTab
    }
  }
});
</script>
<style scoped>
  @media screen and (min-width:1215px){
    div ::v-deep(.spaced-left) {
      padding-right: 2rem;
    }
    div ::v-deep(.spaced-right) {
      padding-left: 2rem;
    }
  }
</style>
